<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm12 md12>
          تكلفة المخزون حسب كل مخزن
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_store"
            :items="stores_of"
            item-text="name"
            item-value="id"
            label=" أختر المخزن "
            persistent-hint
            return-object
            single-line
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>

        <v-flex xs12 sm6 md2>
          <v-btn @click="makhzon_cost">جلب البيانات</v-btn>
        </v-flex>
      </v-layout>
      <v-toolbar flat color="white"> </v-toolbar>
      <p style="font-size:20px;font-weight:bold">
        مجموع تكلفة المخزون : {{ all_cost }}
      </p>

      <v-data-table
        :headers="headers"
        :items="all_makhzon_cost"
        class="elevation-1"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.sell }}</td>
          <td>{{ props.item.reback }}</td>
          <td>{{ props.item.imports }}</td>
          <td>{{ props.item.importsReback }}</td>
          <td>{{ props.item.transferFrom }}</td>
          <td>{{ props.item.transferTo }}</td>
          <td>{{ props.item.price_buy }}</td>
          <td class="text-xs-right">{{ props.item.move }}</td>
          <td class="text-xs-right">{{ props.item.cost }}</td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  store_items_start,
  makhzon_cost,
  delete_start_item_quantity,
  items,
  stores_of,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: "الكود",
        align: "right",
        value: "code"
      },
      {
        text: "الصنف",
        align: "right",
        value: "name"
      },
      {
        text: "مبيعات",
        align: "right",
        value: "sell"
      },
      {
        text: "مرتجعات",
        align: "right",
        value: "reback"
      },
      {
        text: "مشتريات",
        align: "right",
        value: "imports"
      },
      {
        text: "مرتجع مشتريات",
        align: "right",
        value: "importsReback"
      },
      {
        text: "محول من ",
        align: "right",
        value: "transferFrom"
      },
      {
        text: "محول الي",
        align: "right",
        value: "transferTo"
      },
      {
        text: "سعر الشراء",
        align: "right",
        value: "price_buy"
      },
      {
        text: "جرد",
        align: "right",
        value: "move"
      },
      {
        text: "تكلفة مخزون",
        align: "right",
        value: "cost"
      }
    ],
    select_item: { id: "" },
    select_item_edit: { id: "" },
    select_store: { id: "" },
    select_store_edit: { id: "" },
    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    store_items_start: [],
    stores: [],
    items: [],
    editedItem: {
      id: "",
      store_id: "",
      item_id: ""
    },
    newItem: {
      store_id: "",
      item_id: ""
    },
    asnaf_q: "",
    all_makhzon_cost: [],
    stores_of: [],
    all_cost: "",
    masrofat: "",
    one_item_masrof: 0,
    select_store: {}
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    mycode() {
      if (this.store_items_start.length > 0) {
        return (this.code =
          parseInt(
            this.store_items_start[this.store_items_start.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();

    stores_of().then(res => {
      this.loading = false;
      this.stores_of = res.data.stores;
      this.stores_of.push({ id: 0, name: "All Stores" });
    });
  },

  methods: {
    initialize() {},

    makhzon_cost() {
      var frmData = new FormData();
      frmData.append("id", this.select_store.id);
      makhzon_cost(frmData).then(res => {
        this.all_makhzon_cost = res.data.store_items;
        this.all_cost = res.data.all_cost;
        this.pagination.totalItems = res.data.store_items.length;
      });
    },
    editItem(item) {
      //   this.editedItem = Object.assign({}, item)
      this.initialize();
      this.editedIndex = this.store_items_start.indexOf(item);
      this.editedItem.id = item.id;
      this.editedItem.code = item.code;
      this.editedItem.name = item.name;
      this.editedItem.address = item.address;
      this.editedItem.rasid = item.rasid;
      this.select_item_edit = item.branch;
      this.edit_dialog = true;
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.store_items_start.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_start_item_quantity(item.id).then(response => {
            this.loading = false;
            this.store_items_start.splice(index, 1);

            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (
          valid &&
          this.select_item.id != "" &&
          this.select_store.id != "" &&
          this.asnaf_q != ""
        ) {
          this.loading = true;
          this.newItem.item_id = this.select_item.id;
          this.newItem.store_id = this.select_store.id;
          var frmData = new FormData();
          frmData.append("item_id", this.newItem.item_id);
          frmData.append("store_id", this.newItem.store_id);
          frmData.append("asnaf_q", this.asnaf_q);

          makhzon_cost(frmData).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.select_item, this.$options.data().select_item);

            this.store_items_start.push(response.data);
            this.loading = false;
            this.close();
            setInterval(() => {
              this.$router.go(0);
            }, 2000);
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
